<template>
  <div>
    <app-loading :visible="loading"/>
    <!-- <md-button class="md-icon-button md-raised md-primary add-placing" v-on:click="goToAddForm">
      <md-icon>add</md-icon>
    </md-button> -->
    <div class="toolbar">
      <md-field class="list-search-field" md-clearable v-on:md-clear="onSearchClear">
        <md-input :placeholder="translate('nameDocument')"
          v-model="searchTerm"
          type="text"
          class="input-content"
          v-on:keyup.enter="searchDocuments">
        </md-input>
      </md-field>
      <div class="button-add-wrp">
        <md-button class="md-icon-button md-raised md-primary search-placing" v-on:click="searchDocuments">
          <md-icon>search</md-icon>
        </md-button>
        <md-button class="md-icon-button md-raised md-primary add-placing" v-on:click="goToAddForm" v-if="canManage">
          <md-icon>add</md-icon>
        </md-button>
      </div>
    </div>
    <md-table v-model="documents" v-show="!loading">
      <md-table-empty-state
        :md-label="nothingWasFound">
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="type">{{ getDocumentTypeTranslation(item.type) }}</md-table-cell>
        <md-table-cell :md-label="name">{{ item.name }}</md-table-cell>
        <md-table-cell>
          <md-button class="md-icon-button md-raised md-primary"
            :to="{ name: 'DocumentFormEditPage', params: { documentId: item.id }, query: getFormQueryParams(item.id, false) }">
            <md-icon>create</md-icon>
          </md-button>
          <md-button class="md-icon-button md-raised md-primary" target="_blank" :href="item._expend.file.url">
            <md-icon>insert_drive_file</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import DocumentService from '@/common/services/document'
import AppLoading from '@/components/ui/AppLoading.vue'
import HasLoading from '@/mixins/HasLoading.mixin'
import HasListFilter from '@/mixins/HasListFilter.mixin'
import Auth from '@//common/auth/index.js'
import debounce from 'debounce'

export default {
  name: 'DocumentListComponent',
  components: {
    AppLoading
  },
  mixins: [
    HasLoading,
    HasListFilter
  ],
  data () {
    return {
      /** @type {SvpDocument[]} */
      documents: [],
      canManage: Auth.CanManageDocs()
    }
  },
  watch: {
    '$route.query.search_term' (val) {
      this.watchSearchTerm(val)
    } // ,
    // searchTerm (val, oldValue) {
    //   if (val === '' && oldValue !== '') {
    //     this.commitSearchTerm()
    //   }
    // }
  },
  created () {
    this.readDocuments()
    this.initTableDocument()

    this.watchSearchTerm = debounce(this.watchSearchTerm, 300)
  },
  methods: {
    onSearchClear () {
      this.searchTerm = ''
      this.commitSearchTerm()
    },
    watchSearchTerm (val) {
      this.searchTerm = val
      this.readDocuments()
    },
    initTableDocument () {
      this.type = this.translate('type')
      this.name = this.translate('name')
      this.nothingWasFound = this.translate('nothingWasFound')
    },
    searchDocuments () {
      this.commitSearchTerm()
    },
    readDocuments () {
      this.startAppLoading()
      DocumentService.Get(this.searchTerm)
        .then(response => {
          this.documents = response.data
        })
        .catch(error => this.$httpError.handle.call(this, error))
        .then(() => {
          this.commitSearchTerm()
          this.finishAppLoading()
        })
    },
    getDocumentTypeTranslation (type) {
      if (type === 'document') {
        return this.translate('document')
      }
      return type
    },
    goToAddForm () {
      this.$router.push({
        name: 'DocumentFormAddPage',
        query: this.getFormQueryParams()
      })
    },
    getFormQueryParams () {
      const qp = {}

      if (this.appliedSearchTerm) {
        const searchTermKey = this.getQuerySearchTermKey()
        qp[searchTermKey] = this.appliedSearchTerm
      }

      return qp
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/documents/List.vue